import { createFileRoute } from '@tanstack/react-router';

import { SignGroupDetailsRoute } from '@/routes/_authenticated/_management/verkehrszeichen/$adminLevelId/-SignGroupDetailsRoute';

export const Route = createFileRoute(
  '/_authenticated/_management/verkehrszeichen/recherche/$signSupportId_/$signGroupId_/$signId',
)({
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: SignGroupDetailsRoute,
});
